import React from "react";
import {
  Box,
  Select,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PropTypes from "prop-types";

const TablePaginationCustom = ({
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  tableLoading
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");  

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", lg: "flex-end" },
        my: 2,
        gap: 2,
        
        flexWrap: "wrap",
      }}
    >
      {/* Page numbers */}
      <Box
        sx={{
          color: "#FDF9E0",
          fontWeight: 500,
          mr: {xl:2},
          minWidth: "90px",
          textAlign: "center",
        }}
      >
        <Typography
          variant="body2"          
        >
          Page {page + 1} of {Math.max(1, Math.ceil(totalCount / rowsPerPage))}
        </Typography>
      </Box>
      {/* Custom Pagination */}
      <Box sx={{ minWidth: { xs: "100px", sm: "auto" } }}>
        <Pagination
        disabled={tableLoading}
          count={Math.max(1, Math.ceil(totalCount / rowsPerPage))}
          page={page + 1}
          onChange={(event, value) => onPageChange(event, value - 1)}
          color="primary"
          shape="rounded"
          showFirstButton={!isMobile}
          showLastButton={!isMobile}
          siblingCount={isMobile ? 0 : 1}
          boundaryCount={isMobile ? 1 : 2}
          size={isMobile ? "small" : "medium"}
          sx={{
            "& .MuiPaginationItem-root": {
              color: "#FDF9E0",
            //   backgroundColor: "#FDF9E0",
              borderRadius: "6px",
              border:'1px solid #FDF9E0',
              fontWeight: 600,
              minWidth: isMobile ? "28px" : "36px",
              height: isMobile ? "28px" : "36px",
              fontSize: isMobile ? "0.8rem" : "1rem",
              "&.Mui-selected": {
                backgroundColor: "#278C37",
                color: "#fff",
                border: "none",

              },
              "&:hover": {
                backgroundColor: "#278C37",
                color: "#fff",
              },
            },
          }}
        />
      </Box>
      {/* Rows per page dropdown */}
      <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
        <Typography
          sx={{
            color: "#FDF9E0",
            mr: 1,            
          }}
          variant="body2"
        >
          Show
        </Typography>
        <Select
          value={rowsPerPage}
          disabled={tableLoading}
          onChange={onRowsPerPageChange}
          sx={{ 
            color: "#231F20",
            backgroundColor: "#FDF9E0",
            borderRadius: "6px",
            fontWeight: 600,
            height: isMobile ? "28px" : "32px",
            minWidth: isMobile ? "48px" : "64px",
            fontSize: isMobile ? "0.8rem" : "1rem",
            mr: 1,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                fontSize: isMobile ? "0.8rem" : "1rem",
              },
            },
          }}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
        </Select>
        <Typography
          sx={{ color: "#FDF9E0" }}
          variant="body2"          
        >
          entries
        </Typography>
      </Box>
    </Box>
  );
};

TablePaginationCustom.propTypes = {
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default TablePaginationCustom;
